import { Helmet } from 'react-helmet-async';

const SITE_NAME = 'Serenoly';
const SITE_URL = 'https://serenoly.udoemmanuel.com';
const DEFAULT_IMAGE = `${SITE_URL}/static/images/heroImg.jpg`;

// Centralizes per-page <title>/meta so each route is distinct and keyword-relevant
// to search engines, instead of every page sharing the one static index.html title.
const SEO = ({ title, description, path = '/', image = DEFAULT_IMAGE, jsonLd, noIndex = false }) => {
  const fullTitle = title ? `${title} | ${SITE_NAME}` : `${SITE_NAME} — Book a Verified Massage Therapist Online`;
  const url = `${SITE_URL}${path}`;

  return (
    <Helmet>
      <title>{fullTitle}</title>
      {description && <meta name="description" content={description} />}
      <meta name="robots" content={noIndex ? 'noindex, follow' : 'index, follow'} />
      <link rel="canonical" href={url} />

      <meta property="og:title" content={fullTitle} />
      {description && <meta property="og:description" content={description} />}
      <meta property="og:url" content={url} />
      <meta property="og:image" content={image} />

      <meta name="twitter:title" content={fullTitle} />
      {description && <meta name="twitter:description" content={description} />}
      <meta name="twitter:image" content={image} />

      {jsonLd && (
        <script type="application/ld+json">{JSON.stringify(jsonLd)}</script>
      )}
    </Helmet>
  );
};

export default SEO;
